import { Configuration, RedirectRequest } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID,
      authority: process.env.REACT_APP_AUTHORITY,
      redirectUri: process.env.REACT_APP_REDIRECT_URI,
      postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
    },
    system: {
      allowNativeBroker: false,
    },
  };
  
  export const loginRequest = {
    scopes: [process.env.REACT_APP_SCOPES],
  };
  
  export const graphConfig = {
    graphMeEndpoint: process.env.REACT_APP_GRAPH_ME_ENDPOINT,
  };









// /*
//  * Copyright (c) Microsoft Corporation. All rights reserved.
//  * Licensed under the MIT License.
//  */



// /**
//  * Configuration object to be passed to MSAL instance on creation.
//  * For a full list of MSAL.js configuration parameters, visit:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
//  */
// export const msalConfig = {
//   auth: {
//     clientId: 'c397f3f4-6ead-4c1e-9b6f-927ce4b5b848', // This is the ONLY mandatory field that you need to supply.
//     authority: 'https://login.microsoftonline.com/f656c4ed-b8aa-4875-86c1-7ffabc1df59e/', // Defaults to "https://login.microsoftonline.com/common"
//     //redirectUri: 'https://wetsample.themagnigroup.com', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
//     //postLogoutRedirectUri: 'https://wetsample.themagnigroup.com/', // Indicates the page to navigate after logout.
//     redirectUri: 'http://localhost:3000/dashboard', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
//     postLogoutRedirectUri: 'http://localhost:3000/', // Indicates the page to navigate after logout.
//     // redirectUri: 'https://salmon-smoke-0c5f52c0f.5.azurestaticapps.net/dashboard', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
//     // postLogoutRedirectUri: 'https://salmon-smoke-0c5f52c0f.5.azurestaticapps.net/', // Indicates the page to navigate after logout.

//     navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
// },
//     system: {
//         allowNativeBroker: false,
//          // Disables WAM Broker
//     },
//     cache: {
//         cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
//         storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
//     },
//     // system: {
//     //     loggerOptions: {
//     //         loggerCallback: (level, message, containsPii) => {
//     //             if (containsPii) {
//     //                 return;
//     //             }
//     //             switch (level) {
//     //                 case LogLevel.Error:
//     //                     console.error(message);
//     //                     return;
//     //                 case LogLevel.Info:
//     //                     console.info(message);
//     //                     return;
//     //                 case LogLevel.Verbose:
//     //                     console.debug(message);
//     //                     return;
//     //                 case LogLevel.Warning:
//     //                     console.warn(message);
//     //                     return;
//     //                 default:
//     //                     return;
//     //             }
//     //         },
//     //     },
//     // },
// };

// /**
//  * Scopes you add here will be prompted for user consent during sign-in.
//  * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
//  * For more information about OIDC scopes, visit:
//  * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
//  */
// export const loginRequest = {
//     scopes: ['api://c397f3f4-6ead-4c1e-9b6f-927ce4b5b848/wetsample']
// };

// /**
//  * An optional silentRequest object can be used to achieve silent SSO
//  * between applications by providing a "login_hint" property.
//  */
// export const silentRequest = {
//     scopes: ['api://c397f3f4-6ead-4c1e-9b6f-927ce4b5b848/wetsample'],
//     loginHint: "example@domain.net"
// };
